module.exports = __webpack_public_path__ + "img/compensation_benchmarking_banner.e154a12a.jpg";